import { gql } from '../../__generated__/gql'

export const TESTIMONIAL_QUERY = gql(`
  query testimonials {
    testimonials {
      text
      organization
      author
      image
    }
  }
`)
